import { render, staticRenderFns } from "./FilterSummaryOptionActinia.vue?vue&type=template&id=0bfa4bc6&"
import script from "./FilterSummaryOptionActinia.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionActinia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports